<template>
  <div
    class="home new"
    :class="
      extras && extras.statusBarWap && extras.statusBarWap.browse == 'unfixed'
        ? 'bottom-wap'
        : ''
    "
  >
    <Header
      @routerEvent="layoutEvent"
      @logout="logout"
      v-if="extras && seminarInfo"
      :loginUrl="loginUrl"
      :registerUrl="registerUrl"
      :extras="extras"
      :seminarInfo="seminarInfo"
      :memberInfo="memberInfo"
    />

    <Suspension
      ref="suspension"
      v-if="extras && memberInfo && seminarInfo && seminarInfo"
      :extras="extras"
      :isFrozen="isFrozen"
      :signUpStatus="signUpStatus"
      :seminarInfo="seminarInfo"
      :markCode="markCode"
      :memberInfo="memberInfo"
    />
    <div v-for="(item, index) in orderList" :key="index">
      <Banner
        v-if="extras && seminarInfo && item.name == 'kvOrder'"
        :seminarInfo="seminarInfo"
        :memberInfo="memberInfo"
        :isFrozen="isFrozen"
        :signUpStatus="signUpStatus"
        :loginUrl="loginUrl"
        :registerUrl="registerUrl"
        :extras="extras"
      />

      <Introduction
        v-if="extras && seminarInfo && item.name == 'introductionOrder'"
        :seminarInfo="seminarInfo"
        :extras="extras"
      />

      <GuestInfo
        v-if="extras && seminarInfo && item.name == 'guestOrder'"
        :guests="seminarInfo.guests"
        :extras="extras"
      />
      <Schedule
        v-if="extras && seminarInfo && item.name == 'scheduleOrder'"
        :agendas="seminarInfo.agendas"
        :extras="extras"
      />
      <NewInfo
        v-if="extras && newsInfo && item.name == 'newsOrder'"
        :newsInfo="newsInfo"
        :extras="extras"
      />
      <DownloadInfo
        v-if="extras && fileInfo && item.name == 'downloadOrder'"
        :seminarInfo="seminarInfo"
        :memberInfo="memberInfo"
        :fileInfo="fileInfo"
        :extras="extras"
      />
      <Partner
        @partnerDetailClick="partnerDetailClick"
        v-if="extras && partnerInfo && item.name == 'partnerOrder'"
        :partnerInfo="partnerInfo"
        :extras="extras"
      />

      <Custom
        v-if="extras && item.name == 'custom1WapOrder'"
        :extras="extras"
        :index="1"
        :type="'Wap'"
      ></Custom>
      <Custom
        v-if="extras && item.name == 'custom2WapOrder'"
        :extras="extras"
        :index="2"
        :type="'Wap'"
      ></Custom>
      <Custom
        v-if="extras && item.name == 'custom3WapOrder'"
        :extras="extras"
        :index="3"
        :type="'Wap'"
      ></Custom>
    </div>
    <popup
      @PopupClose="PopupClose"
      class="m-pop"
      v-if="popupData.popupShow"
      :popupInfo="popupData.popupInfo"
    ></popup>
    <FooterNew v-if="extras" :extras="extras"></FooterNew>
    <!--  <div class="m-footer">©2023 Sinobase Marketing Technology Corpo</div>-->
  </div>
</template>

<script>
import Header from "@/components/wap/HeaderNew.vue";
import Introduction from "@/components/wap/IntroductionNew.vue";
import Schedule from "@/components/wap/ScheduleNew.vue";
import GuestInfo from "@/components/wap/GuestInfoNew.vue";
import NewInfo from "@/components/wap/NewInfoNew.vue";
import DownloadInfo from "@/components/wap/DownloadInfoNew.vue";
import Partner from "@/components/wap/PartnerNew.vue";
import Banner from "@/components/wap/BannerNew.vue";
import Popup from "../../components/wap/PopupNew";
import Suspension from "@/components/wap/SuspensionNew.vue";
import FooterNew from "@/components/wap/FooterNew.vue";
import Api from "../../service/api";
import { URLS } from "fire-wind-water";
import Custom from "../../components/pc/CostomImg";
import seminarMixin from "../../mixins/seminar";

export default {
  name: "IndexNew",
  data() {
    return {
      fileInfo: null,
      newsInfo: null,
      partnerInfo: null,
      popupData: {
        popupShow: false,
        popupInfo: null,
      },
      isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i),
      sortList: ["Banner", "Introduction"],
    };
  },
  components: {
    Header,
    Introduction,
    Schedule,
    GuestInfo,
    NewInfo,
    DownloadInfo,
    Partner,
    Banner,
    Popup,
    Suspension,
    FooterNew,
    Custom,
  },
  mixins: [seminarMixin],
  created() {
    window.$sk.loading.show();
    this.initPage();
  },
  computed: {
    loginUrl: function () {
      if (URLS.getURL("isSetting") == 1) {
        return "";
      }
      if (this.handleBackUrl && this.seminarInfo) {
        return this.handleBackUrl(this.seminarInfo.login);
      } else {
        return "";
      }
    },
    registerUrl: function () {
      if (URLS.getURL("isSetting") == 1) {
        return "";
      }
      if (this.handleBackUrl && this.seminarInfo) {
        return this.handleBackUrl(this.seminarInfo.register);
      } else {
        return "";
      }
    },
  },
  methods: {
    async initPage() {
      const instanceId = URLS.getURL("instanceId");
      let info = window.$sk.template.get();
      const { globalUserId } = info.user;
      await Api.getArticleList({
        instanceId,
        globalUserId,
        sort: [6, 8],
        isColumnSort: true,
        type: "news", //新闻资讯
      }).subscribe((newsInfoRes) => {
        this.newsInfo = newsInfoRes.content;
      });

      await Api.getArticleList({
        instanceId,
        globalUserId,
        sort: [6, 8],
        isColumnSort: true,
        type: "partner", //合作伙伴
      }).subscribe((partnerInfoRes) => {
        this.partnerInfo = partnerInfoRes.content;
      });

      await Api.getFileList({
        instanceId,
        globalUserId,
      }).subscribe((FileRes) => {
        this.fileInfo = FileRes.content;
      });
      /*window.$sk.loading.hide();*/
    },
    partnerDetailClick(e) {
      let popupData = {
        popupShow: true,
        popupInfo: e,
      };
      this.popupData = popupData;
    },
    PopupClose() {
      let popupData = {
        popupShow: false,
        popupInfo: null,
      };
      this.popupData = popupData;
    },
    logout() {
      const info = window.$sk.template.get();
      info.cookie.removeSession();
      this.$refs.suspension.clearSession();
      this.memberInfo = {
        name: "",
        headImg: "",
        signUpStatus: 0,
      };
    },
    handleBackUrl: function (url) {
      if (!url) {
        return "";
      } else {
        let _url = "";
        const hasBackUrl = url.indexOf("backUrl");
        if (hasBackUrl !== -1) {
          _url =
            url.slice(0, hasBackUrl - 1) +
            "&backUrl=" +
            encodeURIComponent(location.href);
        } else {
          _url = url + "&backUrl=" + encodeURIComponent(location.href);
        }
        return _url;
      }
    },
    downloadEvent(mailbox, fileList) {
      const instanceId = URLS.getURL("instanceId");
      const { globalUserId } = this.template.user;
      Api.getDownloadWithEmail({
        instanceId,
        email: mailbox,
        globalUserId,
        moduleType: 3,
        fileList: fileList,
      }).subscribe(() => {});
    },
    layoutEvent(item) {
      let header = document.querySelectorAll(".m-header");
      let height = header.length > 0 ? header[0].offsetHeight : 0;

      const offsetTop = document.getElementById(item.key).offsetTop;
      window.scrollTo({
        top: offsetTop - height,
        behavior: "smooth",
      });
      //        document.getElementById(item.key).scrollIntoView({
      //          block: "start", //默认跳转到顶部
      //          behavior: "smooth", //滚动的速度
      //        });
    },
    hideBox(e) {
      let isBox = false;
      if (e && e.path) {
        e.path.forEach((path) => {
          if (path.className) {
            let className = path.className.toString();
            if (className.indexOf("m-qrcode") >= 0) {
              isBox = true;
            }
          }
        });
        if (!isBox) {
          this.$refs.suspension.closeBox();
        }
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
